export const deviceModalSections = {
  INFO: "info",
  CERTIFICATES: "certificates",
  DEVICE_GROUPS: "deviceGroups"
};
